"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _ikon = _interopRequireDefault(require("./ikon"));
const MobileTeleHealth = _ref => {
  let {
    title = 'Telehealth',
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({}, props, {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/_react.default.createElement("title", null, title), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M21,2.2H11C8.8,2.2,7.2,3.8,7.2,6V26c0,2.1,1.6,3.8,3.8,3.8h10c2.1,0,3.8-1.6,3.8-3.8V6C24.8,3.8,23.2,2.2,21,2.2z M18.5,27.3h-5V26h5V27.3z M22.5,23.5H9.5V6h13.2v17.6H22.5z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21,19.8v1c0,0.5-0.5,1-1,1h-8c-0.5,0-1-0.5-1-1v-1c0-1.5,1.1-2.8,2.5-3v1.9c-0.5,0.1-0.9,0.6-0.9,1.3 c0,0.8,0.6,1.3,1.3,1.3c0.8,0,1.3-0.6,1.3-1.3c0-0.6-0.4-1-0.9-1.3v-1.9c0.1,0,0.4,0,0.5,0.1c0.4,0.1,0.9,0.3,1.3,0.3 c0.5,0,0.9-0.1,1.3-0.3h0.1v1c-0.9,0.1-1.5,0.9-1.5,1.8v1c0,0.1,0.1,0.4,0.4,0.4l0.8,0.1c0.1,0,0.3,0,0.3-0.1l0.1-0.4 c0-0.1,0-0.3-0.1-0.3l-0.4-0.1v-0.6c0-1.5,2.1-1.5,2.1,0v0.6l-0.4,0.1c-0.1,0-0.1,0.1-0.1,0.3l0.1,0.4c0,0.1,0.1,0.1,0.3,0.1 l0.8-0.1c0.1,0,0.3-0.1,0.3-0.4v-1c0-0.9-0.6-1.6-1.5-1.8v-1.1C19.9,16.8,21,18.3,21,19.8z M13.1,13c0-1.6,1.3-2.9,2.9-2.9 s2.9,1.3,2.9,2.9s-1.3,2.9-2.9,2.9S13.1,14.7,13.1,13z M13.7,19.3c0.3,0,0.5,0.3,0.5,0.5c0,0.3-0.3,0.5-0.5,0.5s-0.4-0.3-0.4-0.5 C13.4,19.6,13.4,19.3,13.7,19.3z"
  })));
};
var _default = exports.default = (0, _ikon.default)(MobileTeleHealth);
MobileTeleHealth.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "MobileTeleHealth",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'Telehealth'",
        "computed": false
      },
      "required": false
    }
  }
};